import { render, staticRenderFns } from "./phoneInput.vue?vue&type=template&id=b20122dc"
import script from "./phoneInput.vue?vue&type=script&lang=js"
export * from "./phoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports